// App.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ScrollToTop from "./ScrollToTop";

import Navbar from '../src/js-coding/navbar.js';
import Homepage from './js-coding/Homepage';
import Services from './js-coding/Services';
import Blog from './js-coding/Blogs';
import Contact from './js-coding/Contact';
import Article1 from './js-coding/Article1';
import Article2 from './js-coding/Article2';
import Article3 from './js-coding/Article3';
import Article4 from './js-coding/Article4';
import Portfolio from './js-coding/Portfolio';
import CS from './js-coding/CaseStudymain.jsx';
import CaseStudiesOne from './js-coding/CS1.jsx';
import CaseStudiesTwo from './js-coding/CS2.jsx';
import Aboutmain from './js-coding/aboutpage.jsx'

function App() {
  return (
    <>
      <Navbar />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Homepage />} />
         <Route path="/about" element={<Aboutmain />} />

        <Route path="/services" element={<Services />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/case-studies" element={<CS />} />
        <Route path="/PrivacyPolicy&TermsofServices" element={<Contact />} />
        <Route path="/article1" element={<Article1 />} />
        <Route path="/article2" element={<Article2 />} />
        <Route path="/article3" element={<Article3 />} />
        <Route path="/article4" element={<Article4 />} />
        <Route path="/casestudy1" element={<CaseStudiesOne />} />
        <Route path="/casestudy2" element={<CaseStudiesTwo />} />
      </Routes>
    </>
  );
}

export default App;


